import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { useNotificationContext } from 'core/states';
import { goTo } from 'core/utils';
import { ICustomerQuote } from 'quotes/types';
import { Variant } from 'theme/enums';

export const SeeExternalOrderButton = ({ quote }: { quote: ICustomerQuote }) => {
  const { t } = useTranslation();

  const { clearNotification } = useNotificationContext();

  return (
    <Button
      text={t('buttonLabelSeeExternalOrder')}
      variant={Variant.SOFT}
      onClick={() => {
        clearNotification();

        goTo(quote.externalOrderUrl, true);
      }}
    />
  );
};
